import { useHotjarStore } from '@/stores/hotjar'
import apiBase, { pathWithPageAndFilters } from './base'
import apiMyBase from './myBase'
import { useOrderStore, PAYMENT_METHOD } from '@/stores/order'

export const buildCustomerData = () => {
  const orderStore = useOrderStore()

  return {
    customer_id: orderStore.customerId,
    customer_email: orderStore.customerEmail,
    customer_name: orderStore.customerName,
    customer_phone: orderStore.customerPhone,
    customer_address_line1: orderStore.customerAddressLine1,
    customer_address_line2: orderStore.customerAddressLine2,
    customer_city: orderStore.customerCity,
    customer_state: orderStore.customerState,
    customer_postal_code: orderStore.customerPostalCode,
    customer_country: orderStore.customerCountry,
    customer_wallet_email: orderStore.customerWalletEmail
  }
}

export const buildPaymentsData = (paymentIntentId: string, amount: number) => {
  return {
    payments: [
      {
        type: 'card',
        amount,
        reference_xid: paymentIntentId
      }
    ]
  }
}

export const createOrder = async (
  paymentIntentId: string,
  cofUsed: boolean = false
): Promise<CreateOrderResponse> => {
  const orderStore = useOrderStore()
  const hotjarStore = useHotjarStore()

  return await apiBase.doPost('/api/orders', {
    payment_intent_id: paymentIntentId,
    wallet: orderStore.paymentMethod || PAYMENT_METHOD.OTHER_PAYMENT,
    items: orderStore.items,
    create_individual_passes: orderStore.createIndividualPasses,
    cof_used: cofUsed,
    metadata: {
      hotjar_session_id: hotjarStore.sessionId
    },
    ...buildCustomerData(),
    ...buildPaymentsData(paymentIntentId, orderStore.totalInCents)
  })
}

export const getOrders = async (
  page: ApiPage,
  filters: ApiFilter[] = []
): Promise<ApiListResponse> => {
  return await apiMyBase.doGet(pathWithPageAndFilters('/api/customers/orders', page, filters))
}

export const getOrder = async (id: string): Promise<CreateOrderResponse> => {
  return await apiBase.doGet(`/api/orders/${id}`)
}

export const resendOrderEmail = async (
  id: string,
  email: string
): Promise<ApiNoContentResponse> => {
  return await apiBase.doPost(`/api/customers/orders/${id}/resend`, { email })
}

export default {
  getOrder,
  getOrders,
  createOrder,
  resendOrderEmail
}
